import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectFlagsTransactions } from 'app/selectors/ugc/FlagsSelector';
import FlagsActions from 'app/actions/FlagsActions';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectFlagEntities } from 'app/selectors/EntitiesSelector';
import FlagUgcForm from './FlagUgcForm';

export class FlagUgcFormContainer extends React.PureComponent {
  render() {
    return <FlagUgcForm {...this.props} />;
  }
}

FlagUgcFormContainer.propTypes = {
  // ownProps
  id: PropTypes.number.isRequired,
  handleClose: PropTypes.func,

  // Redux props
  flagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  flagsTransactions: ImmutablePropTypes.map.isRequired,
  user: userIdentityShape,
  flags: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => ({
  flagsTransactions: selectFlagsTransactions(state),
  user: selectCurrentUser(state),
  flags: selectFlagEntities(state)
});

const mapDispatchToProps = dispatch => ({
  flagsActions: bindActionCreators(FlagsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FlagUgcFormContainer);
